module.exports = __webpack_public_path__ + "step4_C2P_aoyama_bridal.9f70fb6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_C2P_aoyama_bridal.jpg
// module id = DpO1
// module chunks = 0